/**
 * Footstep cadence (DOM-free), vanilla Entity.move: horizontal distance walked
 * on the ground accumulates scaled by 0.6, and a step sounds each time it
 * passes the next whole unit (about every 1.67 blocks walked). Sneaking is
 * silent (vanilla Entity.isSteppingCarefully), flying and mid-air movement too.
 */
export const STEP_SCALE = 0.6;

export interface StepInput {
  dx: number; dz: number;
  onGround: boolean; sneaking: boolean; flying: boolean; inWater: boolean;
}

export class StepTracker {
  private dist = 0;
  private next = 1;

  /** Returns 'step', 'swim' or null for this movement delta. */
  update(i: StepInput): 'step' | 'swim' | null {
    const h = Math.hypot(i.dx, i.dz);
    if (h > 4) { this.reset(); return null; } // teleport
    if (i.flying) return null;
    if (!i.onGround && !i.inWater) return null;
    this.dist += h * STEP_SCALE;
    if (this.dist <= this.next) return null;
    this.next = Math.floor(this.dist) + 1;
    if (i.inWater && !i.onGround) return 'swim';
    if (i.sneaking) return null;
    return 'step';
  }

  reset(): void { this.dist = 0; this.next = 1; }
}
